import { render, staticRenderFns } from "./AnswerToolPage.vue?vue&type=template&id=189847ca&scoped=true"
import script from "./AnswerToolPage.vue?vue&type=script&lang=js"
export * from "./AnswerToolPage.vue?vue&type=script&lang=js"
import style0 from "./AnswerToolPage.vue?vue&type=style&index=0&id=189847ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189847ca",
  null
  
)

export default component.exports